/* Build (group "Work"): artifacts and canvas, website / web-app builder with hosting, mobile apps,
   games, business systems, and the hosting balance (BILL-05). The Design tool is its own feature. */
import { lazy } from 'react';
import { Blocks } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export { ArtifactFrame, httpBridge, IFRAME_SANDBOX, IFRAME_ALLOW, type ArtifactBridge, type ArtifactFrameProps } from './ArtifactFrame';

export default defineFeature({
  id: 'build',
  title: 'Build',
  short: 'Build',
  icon: Blocks,
  group: 'Work',
  route: '/build',
  order: 40,
  rail: true,
  screen: lazy(() => import('./Screen.tsx')),
  capabilities: ['BUILD-01', 'BUILD-02', 'BUILD-03', 'BUILD-04', 'BUILD-05', 'BUILD-07', 'BILL-05'],
  commands: [
    { id: 'new-web', title: 'Build a website or web app', to: '/build/web', keywords: ['site', 'app', 'hosting', 'publish'] },
    { id: 'new-artifact', title: 'New artifact', to: '/build/artifact', keywords: ['canvas', 'html', 'react', 'svg'] },
    { id: 'new-mobile', title: 'Build a mobile app', to: '/build/mobile', keywords: ['android', 'apk', 'play'] },
    { id: 'new-game', title: 'Make a game', to: '/build/game', keywords: ['platformer', 'runner', 'puzzle'] },
    { id: 'new-biz', title: 'Build a business system', to: '/build/biz', keywords: ['crm', 'tracker', 'tables', 'kanban', 'workflow'] },
  ],
});
